import { ChangeDetectionStrategy, Component } from "@angular/core";

/**
 * A stilt fisherman - unique to Sri Lanka's south coast (Weligama/Ahangape),
 * perched on his "petta" pole over the water. A composed, static-camera
 * illustration (not a traveling loop like the plane/train/dolphins): the rod
 * and line idle-bob gently as if working the water, with a ripple pulsing
 * where the line meets the surface. Visible immediately, no entrance delay.
 */
@Component({
  selector: "app-stilt-fisherman",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg class="stilt-fisherman" viewBox="-16 -8 60 100" aria-hidden="true">
      <path
        class="sf-water"
        d="M-16,88 Q-10,85 -4,88 T8,88 T20,88 T32,88 T44,88"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        opacity="0.45"
      />
      <line
        x1="30"
        y1="88"
        x2="30"
        y2="30"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="26"
        y1="31"
        x2="34"
        y2="29"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <g
        stroke="currentColor"
        stroke-width="2"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M30,30 Q26,22 22,16" />
        <circle cx="18" cy="10" r="4" fill="currentColor" stroke="none" />
        <path d="M12,8 L18,-3 L24,8 Z" fill="currentColor" stroke="none" />
        <path d="M30,30 Q25,36 24,38 Q25,42 26,46" />
        <path d="M30,30 Q33,34 34,36 Q34,40 33,44" />
      </g>
      <g class="sf-rod-group">
        <path
          d="M22,16 Q14,18 8,20"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
        />
        <line
          x1="8"
          y1="20"
          x2="-10"
          y2="26"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
        />
        <line
          class="sf-line"
          x1="-10"
          y1="26"
          x2="-2"
          y2="87"
          stroke="currentColor"
          stroke-width="0.7"
          opacity="0.7"
        />
      </g>
      <ellipse
        class="sf-ripple sf-ripple-a"
        cx="-2"
        cy="88"
        rx="4"
        ry="1.3"
        fill="none"
        stroke="currentColor"
        stroke-width="0.7"
      />
      <ellipse
        class="sf-ripple sf-ripple-b"
        cx="-2"
        cy="88"
        rx="4"
        ry="1.3"
        fill="none"
        stroke="currentColor"
        stroke-width="0.7"
      />
    </svg>
  `,
  styles: [
    `
      :host {
        display: block;
        color: var(--color-paper);
        width: 90px;
      }
      .stilt-fisherman {
        display: block;
        width: 100%;
        height: auto;
        overflow: visible;
      }
      .sf-rod-group {
        transform-origin: 22px 16px;
        animation: sf-bob 4.5s ease-in-out infinite;
      }
      @keyframes sf-bob {
        0%,
        100% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(-4deg);
        }
      }
      .sf-ripple {
        transform-origin: -2px 88px;
        opacity: 0;
        animation: sf-ripple 4.5s ease-out infinite;
      }
      .sf-ripple-b {
        animation-delay: -2.25s;
      }
      @keyframes sf-ripple {
        0% {
          transform: scale(0.3);
          opacity: 0.6;
        }
        70% {
          opacity: 0;
        }
        100% {
          transform: scale(2.2);
          opacity: 0;
        }
      }
    `,
  ],
})
export class StiltFisherman {}
